import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../../assets/logo-main.svg';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  const close = () => setIsMenuOpen(false);

  const navItems = [
    { to: '/', label: 'Home' },
    { to: '/#services', label: 'Services' },
    { to: '/products', label: 'Product' },
    { to: '/#contact', label: 'Contact' },
  ];

  const isActive = (to) => (to === '/products' ? pathname === '/products' : false);

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="logo" aria-label="Abidott Solutions home" onClick={close}>
            <img src={logo} alt="Abidott Solutions" className="logo-image" />
          </Link>

          <div className="nav-menu">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`nav-link ${isActive(item.to) ? 'active' : ''}`}
                onClick={close}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="nav-cta">
            <Link to="/#contact" className="btn-cta" onClick={close}>
              Get a Quote
            </Link>
          </div>

          <button
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <div className="mobile-nav-content">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`mobile-nav-link ${isActive(item.to) ? 'active' : ''}`}
                onClick={close}
              >
                {item.label}
              </Link>
            ))}
            <Link to="/#contact" className="mobile-cta" onClick={close}>
              Get a Quote
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
